/**
 * Sends custom event with given type/data.
 * @param {string} type Should match events from constants/index.js
 * @param {*} data
 */
export const sendEvent = (type, data = null) => {
  const event = new CustomEvent(type, {
    detail: data
  });

  window.dispatchEvent(event);
};
